import _styled from "styled-components";
const _excluded = ["style", "className", "children", "disabled", "onClick", "type"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import { stylePropType } from '@adsk/alloy-react-theme';
import { buttonTypePropType } from '../consts';
const StyledButton = styledC.button.withConfig({
  displayName: "BasicButton__StyledButton",
  componentId: "sc-lm3jik-0"
})(["display:inline-flex;align-items:center;justify-content:center;background:none;border:none;border-radius:2px;outline:none;cursor:pointer;text-decoration:none;"]);

/**
 * Basic Button.
 */
var _StyledStyledButton = styledC(StyledButton).withConfig({
  displayName: "BasicButton___StyledStyledButton",
  componentId: "sc-lm3jik-1"
})(["", ""], p => p.$_css);
const BasicButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      children,
      disabled,
      onClick,
      type = 'button'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledStyledButton, _extends({
    ref: ref,
    className: className,
    disabled: disabled,
    onClick: onClick,
    type: type
  }, props, {
    $_css: style
  }), children);
});
BasicButton.displayName = 'BasicButton';
BasicButton.propTypes = {
  /** BasicButton's content */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */className: PropTypes.string,
  /** button html type, eg: submit */
  type: buttonTypePropType,
  /** Disable button functionality */
  disabled: PropTypes.bool,
  /** handle onclick event for button */
  onClick: PropTypes.func
};
export default BasicButton;
//# sourceMappingURL=BasicButton.js.map